import React from 'react'
import MotivosRechazo from '../../../Forms/SharedComponents/containers/MotivosRechazo'

function RechazoBrutoView () {
  return (
    <div style={{ padding: '0 22px' }}>
      <MotivosRechazo />
    </div>
  )
}

export default RechazoBrutoView
